var React = require('react');

function Check12x9 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.002,1.396 L4.461,9.002 L-0.002,4.498 L1.383,3.096 L4.461,6.203 L10.617,-0.006 L12.002,1.396 Z"}));
}

Check12x9.defaultProps = {"width":"12px","height":"9px"};

module.exports = Check12x9;

Check12x9.default = Check12x9;
